interface AnuncioParaAnalise {
  isDeleted: boolean;
  hasFreePlanUsage?: boolean;
  payments: Array<{ status: string }>;
}

export function filtrarAnunciosParaAnalise<T extends AnuncioParaAnalise>(
  anuncios: T[],
): T[] {
  return anuncios.filter(
    (anuncio) =>
      !anuncio.isDeleted &&
      (anuncio.hasFreePlanUsage === true ||
        anuncio.payments.some((payment) => payment.status === "COMPLETED")),
  );
}
